import {Pipe, PipeTransform} from '@angular/core';
import {ExchangeService} from "../exchange/exchange.service";


@Pipe({
    name: 'currency2stablecoin',
    standalone: false
})
export class Currency2StableCointPipe implements PipeTransform {

  constructor(protected exchangeService: ExchangeService) {

  }

  public transform(symbol: string) {

    let stablecoin = this.exchangeService.getStableCoin(symbol);
    return stablecoin;

  }

}

